<!-- Desktop: columna sin caja contenedora, cada boton es su propia superficie; no captura clicks,
     o el hueco reservado a la izquierda del pill se tragaria los del mapa.
     Mobile: dentro del bottom sheet, titulo y filas centradas, y ahi si debe capturar. -->
<div
    #venueLayoutContainer
    class="pointer-events-auto opacity-0 md:pointer-events-none"
    [class]="{'hidden': hideElement()}"
    [attr.aria-hidden]="hideElement()"
>

    <h3 class="md:hidden pb-4 text-center text-base font-semibold text-white">
        {{ translation.getText('venue_layout', 'venue_layout_text_mobile', 'Select a layout') }}
    </h3>

    <!-- Reserva el ancho del pill expandido (`--pill-reserve` en el CSS): :host tiene overflow-y
         auto, que fuerza overflow-x a auto y recortaria lo que crezca hacia la izquierda. -->
    <div class="flex flex-wrap justify-center gap-2.5 md:w-[var(--pill-reserve)] md:flex-col md:flex-nowrap md:items-end">

        @for (entry of options(); track entry.id) {

            <!-- Sin `title` en los iconos: el tooltip nativo sale antes y se quedaria encima del
                 label que revela el hover. En texto se queda: ahi no hay revelado, y truncado no
                 habria forma de leerlo. Un label de icono largo tambien trunca y se queda sin
                 leer: pendiente el cap de longitud en el tool de admin. -->
            <app-button
                class="group pointer-events-auto"
                [attr.title]="entry.showIcon ? null : entry.label"
                [custom]="entry.showIcon ? iconCustom : textCustom"
                [type]="entry.showIcon ? iconButtonType : buttonType"
                [active]="entry.id === venueLayout.venueConfigs.activeId()"
                [label]="entry.showIcon ? '' : entry.label"
                (event)="venueLayout.selectConfiguration(entry.id)"
            >
                @if (entry.showIcon) {
                    <!-- `uppercase` a mano: lo pone `ButtonComponent` en su propio label, y por ng-content no pasa.
                         Revelado: en reposo sin retardo (valor inicial), 1s de hover sostenido, y 0 al
                         tabular. `group-has` se emite despues que `group-hover`, asi que el foco gana. -->
                    <span
                        class="entry-label uppercase flex-none max-w-0 opacity-0 truncate
                               md:group-hover:delay-[1s] md:group-hover:max-w-[calc(var(--pill-reserve)_-_3.75rem)] md:group-hover:opacity-100 md:group-hover:pl-4 md:group-hover:mr-3
                               md:group-has-[:focus-visible]:delay-0 md:group-has-[:focus-visible]:max-w-[calc(var(--pill-reserve)_-_3.75rem)] md:group-has-[:focus-visible]:opacity-100 md:group-has-[:focus-visible]:pl-4 md:group-has-[:focus-visible]:mr-3"
                    >{{ entry.label }}</span>
                    <app-venue-icon class="flex-none size-12" aria-hidden="true" [id]="entry.icon"/>
                }
            </app-button>

        }

    </div>

</div>
